import axios from "axios";
import { useEffect, useState } from 'react';
import { createBrowserHistory } from "history";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// Custom history object
const history = createBrowserHistory();

const redirectURL = (url) => {
    history.push(url);
}

export function UseApiInterceptor() {
    const [showDialog, setShowDialog] = useState(false);

    useEffect(() => {
        const handleRequests = () => {
            axios.interceptors.response.use(
                (response) => {
                    if (response && (response?.data?.status === 403 || response?.data?.status === 401)) {
                        setShowDialog(true);
                    }
                    return response;
                },
                (error) => {
                    if (error && (error.response && error?.response?.status === 403 || error?.response?.status === 401)) {
                        setShowDialog(true);
                    }
                    return Promise.reject(error);
                }
            );
        };
        handleRequests();
        return () => {
            axios.interceptors.response.eject(handleRequests);
        };
    }, []);

    const handleClose = () => {
        setShowDialog(false);
        // redirectURL('/');
        window.location.reload();
    };

    return (
        <Dialog
            open={showDialog}
            onClose={handleClose}
            aria-labelledby="session-expired-dialog-title"            
            fullWidth
            maxWidth='xs'
        >
            <DialogTitle className="_wg-dynamic-text" id="session-expired-dialog-title" sx={{ fontWeight: 'bold' }}>Session Expired (401)</DialogTitle>
            <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', top: 6, right: 8, zIndex: 1 }}>
                <CloseIcon />
            </IconButton>
            <DialogContent className="_wg-dynamic-text" id="session-expired-content" sx={{ paddingY: '0' }}>
                Your session has expired. Please login again.
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} className="_wg-dynamic-text" color="error" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}